import { render, staticRenderFns } from "./ReviewsPortal.vue?vue&type=template&id=3c3cb80a&scoped=true&"
import script from "./ReviewsPortal.vue?vue&type=script&lang=js&"
export * from "./ReviewsPortal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsPortal.vue?vue&type=style&index=0&id=3c3cb80a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3cb80a",
  null
  
)

export default component.exports